/* ============================================================
   BIBERKO — cart bridge
   1) Presreće „Dodaj u korpu” forme koje Horizon ne obrađuje
      (biberko-product-main koristi običan {% form 'product' %},
      koji bi inače radio hard POST i odveo na /cart).
   2) Otvara drawer iz header ikonice.
   3) Osvežava badge sa brojem stavki.
   Učitava se iz sections/biberko-header.liquid, dakle na svim stranicama.
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer-section';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawerHost() {
    return document.getElementById('cart-drawer');
  }

  function openDrawer() {
    var host = drawerHost();
    if (!host) {
      window.location.href = root() + 'cart';
      return;
    }

    if (typeof host.open === 'function') {
      try {
        host.open();
        return;
      } catch (e) {}
    }

    var dlg = host.querySelector('dialog');
    if (dlg) {
      if (!dlg.open && typeof dlg.showModal === 'function') {
        try {
          dlg.showModal();
          return;
        } catch (e) {}
      }
      dlg.setAttribute('open', '');
      return;
    }

    window.location.href = root() + 'cart';
  }

  function refreshDrawer() {
    return fetch(root() + '?sections=' + SECTION_ID, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;

        var current = document.getElementById('shopify-section-' + SECTION_ID);
        if (!current) return;

        var holder = document.createElement('div');
        holder.innerHTML = html;

        var fresh =
          holder.querySelector('#shopify-section-' + SECTION_ID) ||
          holder.firstElementChild;

        if (fresh) current.replaceWith(fresh);
      });
  }

  function refreshCount() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-bib-cart-count]');
        for (var i = 0; i < badges.length; i++) {
          badges[i].textContent = cart.item_count;
          if (cart.item_count > 0) {
            badges[i].removeAttribute('hidden');
          } else {
            badges[i].setAttribute('hidden', '');
          }
        }
      })
      .catch(function () {});
  }

  /* ---------- Dodavanje u korpu bez reload-a ---------- */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.hasAttribute('data-biberko-native')) return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      // Horizon već presreće svoje forme — njih ne diramo.
      if (form.closest('product-form-component')) return;

      event.preventDefault();

      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-busy', 'true');

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          return Promise.all([refreshDrawer(), refreshCount()]);
        })
        .then(function () {
          openDrawer();
        })
        .catch(function () {
          // Ako išta pukne, vrati se na obično slanje forme.
          form.setAttribute('data-biberko-native', '');
          form.submit();
        })
        .then(function () {
          if (button) button.removeAttribute('aria-busy');
        });
    },
    true
  );

  /* ---------- Ikonica korpe otvara drawer ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-bib-cart-open]');
    if (!trigger) return;
    if (!drawerHost()) return; // nema drawera — pusti link na /cart

    event.preventDefault();
    openDrawer();
  });

  /* Badge tacan i pri povratku iz bfcache. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCount();
  });
})();
